import axios from '../../../../shared/axios/axios';
import * as actionTypes from './actionTypes';
import { apiOptions } from '../../../../shared/constants/apiOptions';

const getContactsByTypeStart = () => {
  return {
    type: actionTypes.GET_CONTACTS_BY_TYPE,
  };
};

const getContactsByTypeSuccess = (data) => {
  return {
    type: actionTypes.GET_CONTACTS_BY_TYPE_SUCCESS,
    phonebookContacts: data,
  };
};

const getContactsByTypeFail = (error) => {
  return {
    type: actionTypes.GET_CONTACTS_BY_TYPE_FAIL,
    error: error,
  };
};

export const getContactsByType = (contactType, insuredId, policyId, searchString) => {
  return (dispatch) => {
    dispatch(getContactsByTypeStart());
    const url = `${apiOptions.apiRoot}/phone-book/get-contacts-by-type`;
    axios
      .get(url, {
        params: {
          type: contactType,
          insuredId: insuredId,
          policyId: policyId,
          searchString: searchString,
        },
      })
      .then((response) => {
        dispatch(getContactsByTypeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getContactsByTypeFail(err));
      });
  };
};
